/**
 * Cartpagina — Dawn-geïnspireerd:
 * debounced quantity updates, live-regio, laad-overlay per regel, Shopify-cart als bron (apps/kortingen).
 */
(function () {
  const cartForm = document.querySelector('[data-cart-form]');
  if (!cartForm) return;

  const ON_CHANGE_DEBOUNCE_MS = 350;

  let isUpdating = false;
  let isProgrammaticUpdate = false;
  let cartCurrency = 'EUR';

  const freeShippingThreshold =
    parseInt(cartForm.getAttribute('data-free-shipping-threshold') || '6000', 10) || 6000;

  let shippingProgressEl;
  let shippingBarEl;
  let shippingMessageEl;
  let shippingAmountEl;

  const pendingDebounces = new Map();
  const messageTimeouts = new Map();

  function refreshProgressBarElements() {
    shippingProgressEl =
      cartForm.querySelector('[data-cart-shipping-progress]') || document.querySelector('[data-cart-shipping-progress]');
    shippingBarEl =
      cartForm.querySelector('[data-cart-shipping-bar]') || document.querySelector('[data-cart-shipping-bar]');
    shippingMessageEl =
      cartForm.querySelector('[data-cart-shipping-message]') || document.querySelector('[data-cart-shipping-message]');
    shippingAmountEl =
      cartForm.querySelector('[data-cart-shipping-amount]') || document.querySelector('[data-cart-shipping-amount]');
  }

  refreshProgressBarElements();

  function formatMoney(cents, currencyOverride) {
    const amount = cents / 100;
    const code = currencyOverride || cartCurrency || 'EUR';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: code,
      }).format(amount);
    } catch (e) {
      return new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: 'EUR',
      }).format(amount);
    }
  }

  function announce(message) {
    const el = document.querySelector('[data-cart-live-region]');
    if (!el || !message) return;
    el.textContent = '';
    window.requestAnimationFrame(function () {
      el.textContent = message;
    });
  }

  function setCartError(text) {
    const errEl = document.querySelector('[data-cart-errors]');
    if (!errEl) return;
    errEl.textContent = text || '';
    errEl.classList.toggle('hidden', !text);
  }

  function cancelScheduledQty(key) {
    if (pendingDebounces.has(key)) {
      clearTimeout(pendingDebounces.get(key));
      pendingDebounces.delete(key);
    }
  }

  function scheduleQtyUpdate(key, quantity) {
    cancelScheduledQty(key);
    const id = window.setTimeout(function () {
      pendingDebounces.delete(key);
      updateQuantity(key, quantity, { announce: true });
    }, ON_CHANGE_DEBOUNCE_MS);
    pendingDebounces.set(key, id);
  }

  function enableLineLoading(itemContainer) {
    if (!itemContainer) return;
    itemContainer.classList.add('opacity-70');
    const overlay = itemContainer.querySelector('[data-cart-item-loading]');
    if (overlay) {
      overlay.classList.remove('hidden');
      overlay.classList.add('flex');
      overlay.setAttribute('aria-hidden', 'false');
    }
  }

  function disableLineLoading(itemContainer) {
    if (!itemContainer) return;
    itemContainer.classList.remove('opacity-70');
    const overlay = itemContainer.querySelector('[data-cart-item-loading]');
    if (overlay) {
      overlay.classList.add('hidden');
      overlay.classList.remove('flex');
      overlay.setAttribute('aria-hidden', 'true');
    }
  }

  /**
   * Referentie-regelprijs voor “was”-prijs en korting: max(original_line_price, compare_at × qty).
   * compare_at-unit zit op het DOM-element (cart.js bevat die niet betrouwbaar).
   */
  function referenceLineCents(item, itemContainer) {
    const fin = item.final_line_price != null ? item.final_line_price : item.line_price || 0;
    let ref = item.original_line_price != null ? item.original_line_price : fin;
    const qty = parseInt(item.quantity, 10) || 1;
    if (itemContainer) {
      const compareUnitAttr = itemContainer.getAttribute('data-variant-compare-at-unit');
      if (compareUnitAttr != null && compareUnitAttr !== '') {
        const compareUnit = parseInt(compareUnitAttr, 10);
        if (!Number.isNaN(compareUnit) && compareUnit > 0) {
          ref = Math.max(ref, compareUnit * qty);
        }
      }
    }
    return { reference: ref, final: fin };
  }

  function computeLineDiscountSavingsCents(cart) {
    let sum = 0;
    (cart.items || []).forEach(function (item) {
      const ic = cartForm.querySelector('[data-cart-item][data-item-key="' + item.key + '"]');
      const r = referenceLineCents(item, ic);
      sum += Math.max(0, r.reference - r.final);
    });
    return sum;
  }

  function refreshCartDiscountMarkup(cart, container) {
    if (!container) return;
    container.replaceChildren();
    const apps = cart.cart_level_discount_applications || [];
    apps.forEach(function (discount) {
      const row = document.createElement('div');
      row.className = 'flex items-center justify-between text-sm';

      const left = document.createElement('span');
      left.className = 'text-gray-600';
      const titleWrap = document.createElement('span');
      titleWrap.className = 'flex items-center gap-1';

      const svgNs = 'http://www.w3.org/2000/svg';
      const svg = document.createElementNS(svgNs, 'svg');
      svg.setAttribute('class', 'size-4 text-green-600 shrink-0');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('stroke-width', '2');
      svg.setAttribute('stroke', 'currentColor');
      const path = document.createElementNS(svgNs, 'path');
      path.setAttribute('stroke-linecap', 'round');
      path.setAttribute('stroke-linejoin', 'round');
      path.setAttribute(
        'd',
        'M9 12.75L11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z',
      );
      svg.appendChild(path);

      const titleSpan = document.createElement('span');
      titleSpan.textContent = discount.title || '';

      titleWrap.appendChild(svg);
      titleWrap.appendChild(titleSpan);
      left.appendChild(titleWrap);

      const right = document.createElement('span');
      right.className = 'font-medium text-green-600';
      right.textContent = '-' + formatMoney(discount.total_allocated_amount || 0);

      row.appendChild(left);
      row.appendChild(right);
      container.appendChild(row);
    });
  }

  function syncSavingsUi(cart) {
    const lineSavings = computeLineDiscountSavingsCents(cart);

    const lineRow = cartForm.querySelector('[data-cart-line-savings-row]');
    const lineEl = cartForm.querySelector('[data-cart-line-savings]');
    if (lineRow && lineEl) {
      if (lineSavings > 0) {
        lineRow.classList.remove('hidden');
        lineEl.textContent = formatMoney(lineSavings);
      } else {
        lineRow.classList.add('hidden');
      }
    }

    const discountContainer = cartForm.querySelector('[data-cart-cart-discount-lines]');
    refreshCartDiscountMarkup(cart, discountContainer);
  }

  function showMessage(text, itemKey) {
    setCartError('');
    if (!itemKey) {
      const globalMessageContainer = document.querySelector('[data-cart-message-container]');
      if (globalMessageContainer) {
        const messageText = globalMessageContainer.querySelector('[data-cart-message-text]');
        if (messageText) {
          messageText.textContent = text;
          globalMessageContainer.classList.remove('hidden');
        }
      }
      return;
    }

    const messageContainer = cartForm.querySelector('[data-cart-item-message="' + itemKey + '"]');
    if (!messageContainer) return;

    const messageText = messageContainer.querySelector('[data-cart-item-message-text="' + itemKey + '"]');
    if (!messageText) return;

    if (messageTimeouts.has(itemKey)) {
      clearTimeout(messageTimeouts.get(itemKey));
    }

    messageText.textContent = text;
    messageContainer.classList.remove('hidden');

    const closeButton = messageContainer.querySelector('[data-cart-item-message-close="' + itemKey + '"]');
    if (closeButton && !closeButton.dataset.hasListener) {
      closeButton.addEventListener('click', function () {
        hideMessage(itemKey);
      });
      closeButton.dataset.hasListener = 'true';
    }

    const timeout = setTimeout(function () {
      hideMessage(itemKey);
    }, 7000);
    messageTimeouts.set(itemKey, timeout);
  }

  function hideMessage(itemKey) {
    if (!itemKey) return;

    const messageContainer = cartForm.querySelector('[data-cart-item-message="' + itemKey + '"]');
    if (messageContainer) {
      messageContainer.classList.add('hidden');
    }

    if (messageTimeouts.has(itemKey)) {
      clearTimeout(messageTimeouts.get(itemKey));
      messageTimeouts.delete(itemKey);
    }
  }

  async function fetchCart() {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error('Failed to fetch cart');
    const cart = await response.json();
    if (cart.currency && cart.currency.iso_code) {
      cartCurrency = cart.currency.iso_code;
    }
    return cart;
  }

  function updateShippingProgress(cartTotal) {
    refreshProgressBarElements();

    if (!shippingProgressEl || !shippingBarEl || !shippingMessageEl || !shippingAmountEl) {
      return;
    }

    const total = cartTotal || 0;
    const remaining = Math.max(0, freeShippingThreshold - total);
    const progress = Math.min(100, (total / freeShippingThreshold) * 100);

    if (total >= freeShippingThreshold) {
      shippingProgressEl.style.display = 'block';
      shippingMessageEl.textContent = '🎉 Je hebt gratis verzending!';
      shippingAmountEl.textContent = '';
      shippingBarEl.style.width = '100%';
    } else if (total > 0) {
      shippingProgressEl.style.display = 'block';
      shippingMessageEl.textContent = 'Voeg nog toe voor gratis verzending:';
      shippingAmountEl.textContent = formatMoney(remaining);
      shippingBarEl.style.width = progress + '%';
    } else {
      shippingProgressEl.style.display = 'none';
    }
  }

  async function updateCartDisplay(cart, opts) {
    opts = opts || {};
    const itemCountEl = document.querySelector('[data-cart-item-count]');
    if (itemCountEl) {
      const count = cart.item_count || 0;
      itemCountEl.textContent = count + ' ' + (count === 1 ? 'artikel' : 'artikelen');
    }

    const subtotalEl = cartForm.querySelector('[data-cart-subtotal]');
    const vatEl = cartForm.querySelector('[data-cart-vat]');
    const totalEl = cartForm.querySelector('[data-cart-total]');

    const subtotal = cart.items_subtotal_price || 0;
    const total = cart.total_price || 0;

    if (subtotalEl) subtotalEl.textContent = formatMoney(subtotal);
    if (totalEl) totalEl.textContent = formatMoney(total);

    let catalogSum = 0;
    (cart.items || []).forEach(function (item) {
      const ic = cartForm.querySelector('[data-cart-item][data-item-key="' + item.key + '"]');
      catalogSum += referenceLineCents(item, ic).reference;
    });
    const catalogRow = cartForm.querySelector('[data-cart-catalog-value-row]');
    const catalogVal = cartForm.querySelector('[data-cart-catalog-value]');
    if (catalogRow && catalogVal) {
      if (catalogSum > subtotal) {
        catalogRow.classList.remove('hidden');
        catalogVal.textContent = formatMoney(catalogSum);
      } else {
        catalogRow.classList.add('hidden');
      }
    }

    if (vatEl) {
      // Liquid zet data-cart-taxes-included; /cart.js mist of zet taxes_included soms fout → daarom form als bron.
      const taxesIncluded =
        cartForm.getAttribute('data-cart-taxes-included') === 'true' || cart.taxes_included === true;

      let vatAmount = 0;
      if (taxesIncluded) {
        const s = cart.items_subtotal_price || 0;
        const subtotalExclVat = Math.round(s / 1.21);
        vatAmount = Math.max(0, s - subtotalExclVat);
      } else {
        vatAmount = cart.total_tax || 0;
      }
      vatEl.textContent = formatMoney(vatAmount);
      const vatContainer = vatEl.closest('[data-cart-vat-container]');
      if (vatContainer) {
        vatContainer.style.display = '';
      }
    }

    cart.items.forEach(function (item) {
      const itemContainer = cartForm.querySelector('[data-cart-item][data-item-key="' + item.key + '"]');
      if (!itemContainer) return;

      const priceEl = itemContainer.querySelector('[data-item-price="' + item.key + '"]');
      const originalEl = itemContainer.querySelector('[data-item-original-price="' + item.key + '"]');

      const refData = referenceLineCents(item, itemContainer);
      const referenceLine = refData.reference;
      const final = refData.final;

      if (priceEl) {
        priceEl.textContent = formatMoney(final);
      }
      if (originalEl) {
        if (referenceLine > final) {
          originalEl.classList.remove('hidden');
          originalEl.classList.add('inline');
          originalEl.textContent = formatMoney(referenceLine);
        } else {
          originalEl.classList.add('hidden');
          originalEl.classList.remove('inline');
        }
      }

      const discountRow = itemContainer.querySelector('[data-item-discount-row="' + item.key + '"]');
      const discountAmt = itemContainer.querySelector('[data-item-discount-amount="' + item.key + '"]');
      const discountPct = itemContainer.querySelector('[data-item-discount-pct="' + item.key + '"]');
      const lineSave = Math.max(0, referenceLine - final);
      if (discountRow && discountAmt) {
        if (lineSave > 0) {
          discountRow.classList.remove('hidden');
          discountAmt.textContent = formatMoney(lineSave);
          if (discountPct) {
            if (referenceLine > 0) {
              discountPct.textContent = '\u2212' + Math.round((lineSave / referenceLine) * 100) + '%';
              discountPct.classList.remove('hidden');
            } else {
              discountPct.classList.add('hidden');
            }
          }
        } else {
          discountRow.classList.add('hidden');
        }
      }

      const quantityInput = itemContainer.querySelector('[data-cart-quantity][data-item-key="' + item.key + '"]');
      if (quantityInput) {
        const newQuantity = parseInt(item.quantity, 10) || 1;
        if (parseInt(quantityInput.value, 10) !== newQuantity) {
          isProgrammaticUpdate = true;
          quantityInput.value = String(newQuantity);
          isProgrammaticUpdate = false;
        }
      }
    });

    syncSavingsUi(cart);

    updateShippingProgress(cart.items_subtotal_price || 0);

    if (opts.announceSuccess && opts.productTitle) {
      announce('Aantal bijgewerkt voor ' + opts.productTitle + '.');
    }
  }

  async function updateQuantity(key, quantity, opts) {
    opts = opts || {};
    if (opts.announce === undefined) opts.announce = false;
    if (isUpdating) return;
    if (quantity < 1) {
      await removeItem(key);
      return;
    }

    const itemContainer = cartForm.querySelector('[data-cart-item][data-item-key="' + key + '"]');
    if (!itemContainer) {
      console.error('Cart item container not found for key:', key);
      return;
    }

    const quantityInput = itemContainer.querySelector('[data-cart-quantity][data-item-key="' + key + '"]');
    if (quantityInput && quantityInput.disabled) {
      return;
    }

    const originalQuantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : quantity;

    const decreaseBtn = itemContainer.querySelector('[data-cart-decrease][data-item-key="' + key + '"]');
    const increaseBtn = itemContainer.querySelector('[data-cart-increase][data-item-key="' + key + '"]');

    isUpdating = true;
    setCartError('');
    enableLineLoading(itemContainer);

    if (quantityInput) quantityInput.disabled = true;
    if (decreaseBtn) decreaseBtn.disabled = true;
    if (increaseBtn) increaseBtn.disabled = true;

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id: key, quantity: quantity }),
      });

      let responseData;
      try {
        responseData = await response.json();
      } catch (e) {
        console.error('Failed to parse response:', e);
        throw new Error('Er is een fout opgetreden bij het bijwerken van de winkelwagen.');
      }

      if (!response.ok) {
        let errorMessage = 'Er is een fout opgetreden bij het bijwerken van de winkelwagen.';
        if (responseData && responseData.description) {
          errorMessage = responseData.description;
        } else if (responseData && responseData.message) {
          errorMessage = responseData.message;
        }

        if (quantityInput) {
          quantityInput.value = originalQuantity;
        }

        throw new Error(errorMessage);
      }

      const cartResult = await fetchCart();
      const title = itemContainer.getAttribute('data-product-title') || 'dit artikel';

      await updateCartDisplay(cartResult, {
        announceSuccess: opts.announce === true,
        productTitle: title,
      });

      hideMessage(key);

      const apiQty =
        cartResult.items &&
        cartResult.items.find(function (i) {
          return i.key === key;
        });
      const settledQty = apiQty ? parseInt(apiQty.quantity, 10) : quantity;
      if (quantityInput && settledQty !== quantity && settledQty !== parseInt(quantityInput.value, 10)) {
        announce(
          'Het gevraagde aantal voor ' +
            title +
            ' kon niet worden toegepast. Nieuw aantal: ' +
            settledQty +
            '.',
        );
      }
    } catch (error) {
      console.error('Error updating quantity:', error);
      const errorMessage = error.message || 'Er is een fout opgetreden bij het bijwerken van de winkelwagen.';
      showMessage(errorMessage, key);
      setCartError(errorMessage);

      if (quantityInput) {
        quantityInput.value = originalQuantity;
      }
    } finally {
      if (quantityInput) quantityInput.disabled = false;
      if (decreaseBtn) decreaseBtn.disabled = false;
      if (increaseBtn) increaseBtn.disabled = false;
      disableLineLoading(itemContainer);
      isUpdating = false;
    }
  }

  async function removeItem(key) {
    if (isUpdating) return;
    const itemContainer = cartForm.querySelector('[data-cart-item][data-item-key="' + key + '"]');
    const title = itemContainer ? itemContainer.getAttribute('data-product-title') || 'Artikel' : 'Artikel';

    isUpdating = true;
    setCartError('');
    if (itemContainer) enableLineLoading(itemContainer);

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ id: key, quantity: 0 }),
      });

      if (!response.ok) throw new Error('Failed to remove item');

      const cartResult = await fetchCart();

      const itemEl = cartForm.querySelector('[data-cart-item][data-item-key="' + key + '"]');
      if (itemEl) {
        disableLineLoading(itemEl);
        itemEl.style.transition = 'opacity 0.25s ease, transform 0.25s ease';
        itemEl.style.opacity = '0';
        itemEl.style.transform = 'translateX(-12px)';
        window.setTimeout(function () {
          itemEl.remove();
          updateCartDisplay(cartResult).then(function () {
            announce(title + ' verwijderd uit je winkelwagen.');
            if (cartResult.item_count === 0) {
              window.location.reload();
            }
          });
        }, 240);
      } else {
        await updateCartDisplay(cartResult);
        announce(title + ' verwijderd uit je winkelwagen.');
        if (cartResult.item_count === 0) {
          window.location.reload();
        }
      }
    } catch (error) {
      console.error('Error removing item:', error);
      const msg = 'Er is een fout opgetreden bij het verwijderen van het artikel.';
      showMessage(msg, key);
      setCartError(msg);
      const stillThere = cartForm.querySelector('[data-cart-item][data-item-key="' + key + '"]');
      if (stillThere) disableLineLoading(stillThere);
    } finally {
      isUpdating = false;
    }
  }

  cartForm.addEventListener('click', async function (e) {
    const decreaseBtn = e.target.closest('[data-cart-decrease]');
    const increaseBtn = e.target.closest('[data-cart-increase]');
    const removeBtn = e.target.closest('[data-cart-remove]');

    if (decreaseBtn && decreaseBtn.disabled) return;
    if (increaseBtn && increaseBtn.disabled) return;

    if (decreaseBtn) {
      e.preventDefault();
      const keyDec = decreaseBtn.dataset.itemKey;
      cancelScheduledQty(keyDec);
      const itemDec = decreaseBtn.closest('[data-cart-item]');
      if (itemDec) {
        const qIn = itemDec.querySelector('[data-cart-quantity][data-item-key="' + keyDec + '"]');
        if (qIn && !qIn.disabled) {
          const newQuantity = Math.max(1, parseInt(qIn.value, 10) - 1);
          await updateQuantity(keyDec, newQuantity, { announce: true });
        }
      }
    }

    if (increaseBtn) {
      e.preventDefault();
      const keyInc = increaseBtn.dataset.itemKey;
      cancelScheduledQty(keyInc);
      const itemInc = increaseBtn.closest('[data-cart-item]');
      if (itemInc) {
        const qIn2 = itemInc.querySelector('[data-cart-quantity][data-item-key="' + keyInc + '"]');
        if (qIn2 && !qIn2.disabled) {
          await updateQuantity(keyInc, parseInt(qIn2.value, 10) + 1, { announce: true });
        }
      }
    }

    if (removeBtn && !removeBtn.disabled) {
      e.preventDefault();
      const keyRm = removeBtn.dataset.itemKey;
      cancelScheduledQty(keyRm);
      await removeItem(keyRm);
    }
  });

  cartForm.addEventListener('input', function (e) {
    if (!e.target.matches('[data-cart-quantity]')) return;
    if (isProgrammaticUpdate) return;
    const input = e.target;
    if (input.disabled) return;

    const keyIn = input.dataset.itemKey;
    let qty = parseInt(input.value, 10);
    if (!Number.isFinite(qty)) return;
    if (qty < 1) return;

    scheduleQtyUpdate(keyIn, qty);
  });

  cartForm.addEventListener(
    'blur',
    function (e) {
      if (!e.target.matches('[data-cart-quantity]')) return;
      if (isProgrammaticUpdate) return;
      const input = e.target;
      if (input.disabled) return;

      const keyB = input.dataset.itemKey;
      cancelScheduledQty(keyB);

      let qtyB = parseInt(input.value, 10);
      if (!Number.isFinite(qtyB) || qtyB < 1) {
        qtyB = 1;
        input.value = '1';
      }
      updateQuantity(keyB, qtyB, { announce: true });
    },
    true,
  );

  cartForm.addEventListener('submit', function (e) {
    const submitButton = e.submitter;
    if (submitButton && submitButton.name !== 'checkout') {
      e.preventDefault();
    }
  });

  const globalClose = document.querySelector('[data-cart-message-close]');
  const globalContainer = document.querySelector('[data-cart-message-container]');
  if (globalClose && globalContainer) {
    globalClose.addEventListener('click', function () {
      globalContainer.classList.add('hidden');
    });
  }

  (async function initShippingProgress() {
    try {
      const cartInit = await fetchCart();
      updateShippingProgress(cartInit.items_subtotal_price || 0);
    } catch (error) {
      console.error('Error initializing shipping progress:', error);
    }
  })();

  const kassakoopjesSection = document.querySelector('[data-kassakoopjes]');
  if (kassakoopjesSection) {
    kassakoopjesSection.addEventListener('click', async function (e) {
      const btn = e.target.closest('[data-kassakoopje-add]');
      if (!btn) return;
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      const messageEl = document.getElementById('kassakoopjes-message');
      const messageTextEl = messageEl && messageEl.querySelector('[data-kassakoopjes-message-text]');
      const originalText = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = 'Toevoegen…';
      if (messageEl) {
        messageEl.classList.add('hidden');
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
        const data = await response.json().catch(function () {
          return {};
        });

        if (!response.ok) {
          const errMsg = data.description || data.message || 'Kon product niet toevoegen.';
          if (messageTextEl) {
            messageTextEl.textContent = errMsg;
            messageTextEl.classList.remove('text-green-700');
            messageTextEl.classList.add('text-red-700');
          }
          if (messageEl) messageEl.classList.remove('hidden');
          btn.disabled = false;
          btn.innerHTML = originalText;
          return;
        }

        window.location.reload();
      } catch (err) {
        console.error('Kassakoopje add error:', err);
        if (messageTextEl) {
          messageTextEl.textContent = 'Er is iets misgegaan. Probeer het opnieuw.';
          messageTextEl.classList.remove('text-green-700');
          messageTextEl.classList.add('text-red-700');
        }
        if (messageEl) messageEl.classList.remove('hidden');
        btn.disabled = false;
        btn.innerHTML = originalText;
      }
    });
  }
})();
